import React from 'react';
import { TubeRow, GapElement, PlatedSpacerBox, SpacerBox, FillElement, StaticFill, SpacerRingCombo } from './primitives';

export const LipRollingStation = ({ spacers, topContainerWidth, bottomContainerWidth, scale, leftExtWidth, spacerAllocation, topFillRight, bottomFillRight, topFillRightWidth, bottomFillRightWidth, topLeftPad, bottomLeftPad, title }) => {
  const hasLeftLip = spacers.lipGapLeft > 0;
  const hasRightLip = spacers.lipGapRight > 0;
  
  // Only render if at least one lip/short-side fold exists
  if (!hasLeftLip && !hasRightLip) return null;

  const feedingExtra = 0.5;
  const leftIsShort = !!spacers.leftIsShort;
  const rightIsShort = !!spacers.rightIsShort;
  
  // Left gap value (unchanged)
  const leftGapValue = hasLeftLip ? spacers.lipGapLeft + feedingExtra : feedingExtra;
  
  // Build note for short sides being folded here
  let shortNote = '';
  if (leftIsShort && rightIsShort) shortNote = '(folding both short sides here)';
  else if (leftIsShort) shortNote = '(folding short left side here)';
  else if (rightIsShort) shortNote = '(folding short right side here)';

  return (
    <div className="bg-zinc-800 rounded-lg p-2 sm:p-3 border border-zinc-700 print:bg-gradient-to-br print:from-blue-50 print:to-indigo-50 print:border-blue-200" style={{ overflow: 'visible' }} data-testid="lip-rolling-station">
      <h3 className="font-semibold text-blue-400 mb-1 sm:mb-2 flex items-center gap-1.5 text-xs sm:text-sm print:text-blue-900">
        <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" strokeWidth="2"/>
          <line x1="9" y1="3" x2="9" y2="21" strokeWidth="2"/>
          <line x1="15" y1="3" x2="15" y2="21" strokeWidth="2"/>
        </svg>
        {title || 'Stations 2-4 (Lip Rolling)'}
        {shortNote && (
          <span className="text-[10px] sm:text-xs font-normal text-blue-300/80 print:text-blue-700" data-testid="lip-short-side-note">
            {shortNote}
          </span>
        )}
      </h3>
      
      <div className="space-y-1 sm:space-y-2" style={{ overflow: 'visible' }}>
        {/* Top Station Tube - plated spacer */}
          <TubeRow>
          <StaticFill width={topLeftPad} />
          <GapElement width={leftExtWidth} value={leftGapValue} hideValue={!hasLeftLip} />
          <PlatedSpacerBox width={topContainerWidth} value={spacers.top_2_4} colorClass="bg-gradient-to-br from-blue-400 to-blue-500 border-blue-600" scale={scale} />
          <FillElement width={topFillRightWidth} value={topFillRight} />
        </TubeRow>

        {/* Bottom Station Tube */}
          <TubeRow>
          <StaticFill width={bottomLeftPad} />
          <GapElement width={leftExtWidth} value={leftGapValue} hideValue={!hasLeftLip} />
          <SpacerBox width={bottomContainerWidth} value={spacers.bottom_2_4} colorClass="bg-gradient-to-br from-indigo-500 to-indigo-600 border-indigo-700" />
          <FillElement width={bottomFillRightWidth} value={bottomFillRight} />
        </TubeRow>
        {/* Spacer ring combination */}
        <div className="flex items-center gap-2 ml-1">
          <span className="text-[10px] text-zinc-400 print:text-gray-500">Rings:</span>
          <SpacerRingCombo groups={spacerAllocation || []} />
        </div>
      </div>
    </div>
  );
};

// Feeding Station
